'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmpty = exports.keySign = undefined;

var _jsMd = require('js-md5');

var _jsMd2 = _interopRequireDefault(_jsMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keySign = exports.keySign = function keySign(params, secret) {

    var str = '';
    Object.keys(params).sort().map(function (key) {
        if (isEmpty(params[key])) {
            return;
        }
        str = str + key + '=' + params[key] + '&';
    });

    if (str != '') {
        str = str.substring(0, str.length - 1);
    }

    str = str + "&app_secret=" + secret;

    var sign = (0, _jsMd2.default)(str).toUpperCase();
    console.log('keySign str, sign=', str, sign);
    return sign;
};

var isEmpty = exports.isEmpty = function isEmpty(obj) {

    if (typeof obj === 'undefined' || obj === null || obj === '') {
        return true;
    }
    return false;
};
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/util.js
// module id = cU5c
// module chunks = 0